// extracted by mini-css-extract-plugin
export default {"Formulaire":"PageEditionLaboratoire_Formulaire__AgFpv"};